// src/api/api.js
import axios from 'axios';

const apis = axios.create({
    baseURL: 'https://dymesenergy.gst-panel.com',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    timeout: 10000
});



// Servicio para Departamentos
export const DepartamentoService = {
    obtenerTodos: () => apis.get('/get/obtener_departamentos.php')
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        })),

    obtenerPorId: (id) => apis.get(`/get/obtener_departamento_id.php?id=${id}`)
};
// Servicio para Municipios
export const MunicipioService = {
    // Obtener municipios por ID de departamento
    obtenerPorDepartamento: (idDepartamento) =>
        apis.get(`/get/obtener_municipios.php?id_departamento=${idDepartamento}`)
            .then(response => ({
                data: response.data.success ? response.data.data : [],
                success: response.data.success,
                message: response.data.message || ''
            })),

    // ✅ Nuevo: Obtener municipio por ID de municipio
    obtenerPorId: (idMunicipio) =>
        apis.get(`/get/get_municipio_por_id.php?id_municipio=${idMunicipio}`)
            .then(response => ({
                data: response.data.success ? response.data.data : null,
                success: response.data.success,
                message: response.data.message || ''
            }))
};
// Servicio para Empresas
export const EmpresaService = {


    obtenerPorDepartamento: (idDepartamento) =>
        apis.get(`/get/obtener_empresas.php?id_departamento=${idDepartamento}`)
            .then(response => ({
                data: Array.isArray(response.data) ? response.data : response.data?.data || []
            }))
};

// Servicio para Estratos
export const EstratoService = {
    obtenerTodos: () => apis.get('/get/obtener_estratos.php')
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        })),

};

// // Servicio para Tipos de Persona
export const TipoPersonaService = {
    obtenerTodos: () => apis.get('/get/obtener_tipospersona.php')
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        })),

    obtenerPorId: (id) => apis.get(`/get/obtener_tipopersona_id.php?id=${id}`)
};

// Servicio para Tipos de Techo
export const TipoTechoService = {
    obtenerTodos: () => apis.get('/get/obtener_tipostecho.php')
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        })),

    obtenerPorId: (id) => apis.get(`/get/obtener_tipotecho_id.php?id=${id}`)
};

// // Servicio para Valores KW
export const ValorKWService = {
    obtenerTodos: () => apis.get('/get/obtener_valoreskw.php'),

    obtenerPorEmpresaEstrato: (idEmpresa, idEstrato) =>
        apis.get(`/get/obtener_valoreskw.php?id_empresa=${idEmpresa}&id_estrato=${idEstrato}`)
            .then(response => ({
                data: Array.isArray(response.data) ? response.data : response.data?.data || []
            }))
};

// Servicio para Recursos Solares
export const RecursoSolarService = {
    obtenerTodos: () => apis.get('/get/obtener_recursosolar.php'),

    obtenerPorCiudad: (idCiudad) =>
        apis.get(`/get/obtener_recursosolar.php?id_ciudad=${idCiudad}`)
            .then(response => ({
                data: Array.isArray(response.data) ? response.data : response.data?.data || []
            }))
};




// Servicio para Interesados
export const InteresadoService = {
    obtenerTodos: () => apis.get('/get/obtener_interesados.php')
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        })),

    obtenerPorId: (id) => apis.get(`/get/obtener_interesados.php?id=${id}`)
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        })),
};


// Servicio para Clientes - Versión mejorada
export const ClienteService = {
    obtenerTodos: () => apis.get('/get/obtener_clientes.php')
        .then(response => ({
            success: true,
            data: Array.isArray(response.data) ? response.data : response.data?.data || [],
            count: response.data?.count || 0
        }))
        .catch(error => ({
            success: false,
            message: error.response?.data?.message || 'Error al obtener clientes',
            error: error.message
        })),

    obtenerPorId: (id) => apis.get(`/get/obtener_cliente_id.php?id=${id}`)
        .then(response => ({
            success: true,
            data: response.data, // No necesitas convertirlo a array
            count: 1 // Como es un solo registro
        }))
        .catch(error => ({
            success: false,
            message: error.response?.data?.message || 'Error al obtener el cliente',
            error: error.message
        })),
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////                    POST           //////////////////////////////////////////////////////






export default apis;